import React, { Component } from 'react';
import Config from '../../config.js'
import Urls from '../../common/Urls';
import Styles from "../../styles/Styles";

export default class FilesListing extends Component {

    state = {
        arrFiles: null
    }

    constructor(props){
        super(props);
        this.state.arrFiles = Config.program.files;
    }

    getCurrentDocumentUrl(){
        return this.getDocumentUrl(this.state.currentFileIndex);
    }

    getCurrentDocumentName(){
        return this.getDocumentName(this.state.currentFileIndex);
    }

    getCurrentDocumentPageCount(){
        return this.getDocumentPageCount(this.state.currentFileIndex);
    }

    getDocumentName(index){
        let arrPieces = this.state.arrFiles[index].split(".");
        arrPieces.splice(arrPieces.length-1,1);
        return arrPieces.join(".");
    }

    getDocumentUrl(index){
        return Urls.getDocumentPath()+"/"+this.state.arrFiles[index];
    }

    getDocumentPageCount(index){
        return this.state.arrPagesRead[index]?this.state.arrPagesRead[index].length:0;
    }






    renderFileList(listClass = "margin-top-l files-list" ){
        let ctx = this;

        let liFiles = this.state.arrFiles.map(function(name, i){
            let displayName = ctx.getDocumentName(i);

            return <a key={i} className="list-group-item" ><span>{displayName}</span></a>;

        })

        return (

            <div className={"list-group margin-left-s "+listClass}>
                {liFiles}
            </div>
        );
    }





    render() {

        return (
            <div>
                <header style={Styles.Style.bgColorMain} className="heading-small">
                    <h1 className="heading-small-title wizard-title">Affiliation {Config.program.name}</h1>
                </header>
                <div className={"pdf-intro"}>
                    <p>
                        Bienvenue dans la procédure dématérialisée d'affiliation à {Config.program.name}.
                    </p>
                    <p>
                        Après avoir rempli toutes les informations vous concernant, vous serez amené à valider chacun des document suivants:
                        {this.renderFileList("embed-files-list")}
                    </p>
                    <button style={Styles.Style.bgColorSecondary} className="margin-top-m btn btn-lg btn-primary-primary" onClick={this.props.onButtonClicked}>Remplir le dossier d'affiliation</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pdf/FilesListing.js